import React, {
  MouseEventHandler,
  useContext,
  useEffect,
  useState
} from "react";
import { Grid, Stack } from "@mui/material";
import { Routes, Route, useNavigate } from "react-router-dom";
import {
  StyledContainer,
  StyledHeader,
  StyledButtonConatiner
} from "./Provider.styles";
import Button from "components/shared/Button/Button";
import Users from "./Subviews/Users/Users";
import Managers from "./Subviews/Managers/Managers";
import API from "api";
import { GlobalContext } from "context/Provider";
import Reports from "views/Provider/Subviews/Reports/Reports";
import Statistics from "views/Admin/subviews/Statistics/Statistics";
import Session from "helpers/session";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Upsert from "./Upsert/Upsert";
import Orders from "../Orders/Orders";
import Configurations from "./Subviews/Configurations/Configurations";
import { host, socket_url } from "../../api/kore";
import io from "socket.io-client";
import { toLastFirstName } from "helpers/variables";
import GlobalThresholds from "./Subviews/GlobalThresholds/GlobalThrsholds";

interface KoreListInterface {
  cid: string;
  pages: number;
  page: number;
  items: any[];
}

export const ButtonArray = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const userType = window.location.pathname.split("/").pop();
  const { provider } = useContext(GlobalContext);
  const [loggedInClient, setLoggedInClient] = useState<any>();

  useEffect(() => {
    setLoggedInClient(provider?.loggedInClient);
  }, [provider?.loggedInClient]);

  return (
    <StyledButtonConatiner container>
      <Grid item xs={0.1} md={0.1} lg={0.2} xl={0.3} />
      {loggedInClient && loggedInClient.roles === "Client,Provider" && (
        <Grid item xs={3} md={2.2} lg={1.8} xl={1.5}>
          <Button
            variant="primary"
            onClick={() => {
              navigate(`${window.location.pathname}/new`);
            }}
          >
            {userType === "members"
              ? t("u-new-member")
              : t("u-new-coordinator")}
          </Button>
        </Grid>
      )}
      <Grid item xs={0.5} md={1} lg={2} xl={3} />
      <Grid item xs={3} md={3} lg={2} xl={2}>
        <Stack direction="row" spacing={1}>
          <Button
            variant={userType === "members" ? "info" : "warning"}
            onClick={() => {
              navigate("/provider/coordinators");
            }}
          >
            {t("u-coordinators")}
          </Button>
          <Button
            variant={userType === "coordinators" ? "info" : "warning"}
            onClick={() => {
              navigate("/provider/members");
            }}
          >
            {t("u-members")}
          </Button>
        </Stack>
      </Grid>
      <Grid item xs={0.9} md={0.9} lg={1.8} xl={2.7} />
      <Grid item xs={1} md={1} lg={2} xl={2.5}>
        {/*<Stack direction="row" spacing={1}><Button id={'btn-all'} variant="info" onClick={handleFilterClick} disabled={true}>{t('u-all')}</Button><Button id={'btn-locked'} variant="primary" onClick={handleFilterClick}>{t('u-locked')}</Button><Button id={'btn-active'} variant="primary" onClick={handleFilterClick}>{t('u-active')}</Button><Button id={'btn-archive'} variant="primary" onClick={handleFilterClick}>{t('u-archive')}</Button></Stack>*/}
      </Grid>
    </StyledButtonConatiner>
  );
};

export default function Provider() {
  const { t } = useTranslation();
  const {
    providerDispatch,
    configDispatch,
    devicesDispatch,
    notificationsDispatch
  } = useContext(GlobalContext);
  const [collectiveClient] = useState<any[]>([{ Unassigned: {} }]);
  const [organizations] = useState<string[]>([]);

  const removeUser = (isCoordinator: boolean) => (event: any) => {
    if (window.confirm("Are you sure you want to archive this user?")) {
      let apiCall = API.kore.members.remove(
        event.target.dataset.id,
        Session.crackCookieToken("provider")
      );
      if (isCoordinator) {
        apiCall = API.kore.coordinator.remove(
          event.target.dataset.id,
          Session.crackCookieToken("provider")
        );
      }
      apiCall.then((removeRes) => {
        window.location.pathname = `/provider/${
          isCoordinator ? "coordinator" : "member"
        }s`;
      });
    }
  };

  let orgSorter = (res: any) => {
    const sortValue = res.phone;
    if (sortValue && sortValue !== "-" && !organizations.includes(sortValue)) {
      organizations.push(sortValue);
      collectiveClient[0][sortValue] = { [res.id]: res };
    } else if (
      sortValue &&
      organizations.includes(sortValue) &&
      !Object.keys(collectiveClient[0][sortValue]).includes(res.id)
    ) {
      collectiveClient[0][sortValue][res.id] = res;
    } else if (
      sortValue === "-" &&
      !Object.keys(collectiveClient[0].Unassigned).includes(res.id)
    ) {
      collectiveClient[0].Unassigned[res.id] = res;
    }
  };

  const callRefresh = () => {
    API.kore.coordinator
      .getFullCoordList(Session.crackCookieToken("provider"))
      .then((list) => {
        const filteredList = (list: any[]) => {
          console.log("Full Coordinators list", list);
          return list.map((item: any) => {
            return {
              id: item.id,
              email: item.email,
              name: toLastFirstName(item.username),
              phone: item.phone || "-",
              role: item.roles,
              // organization: item.organization,
              lastActivity:
                moment(item.updatedAt).format("MMM DD, YYYY HH:mm") || "-",
              registerdat: moment(item.createdAt).format("MMM DD, YYYY") || "-",
              actions: (
                <Button
                  dataId={item.id}
                  variant="primary"
                  onClick={removeUser(true)}
                >
                  {t("u-archive")}
                </Button>
              )
            };
          });
        };
        const payload = filteredList(list);
        payload.forEach(orgSorter);
        providerDispatch({ type: "UPDATE_COORD_LIST", payload: payload });
      });
    API.kore.configurations.getConfigurations().then((conf) => {
      configDispatch({ type: "OPTIONS_UPLOAD", payload: conf });
    });
    API.kore.members
      .getAll(Session.crackCookieToken("provider"), "scope=provider&")
      .then((list) => {
        console.log("Full members list", list);
        const filteredList = (list: KoreListInterface) => {
          return list.items.map((item: any) => {
            return {
              id: item.id,
              email: item.email,
              name: toLastFirstName(item.username),
              phone: item.phone || "-",
              lastactivity:
                moment(item.updatedAt).format("MMM DD, YYYY HH:mm") || "-",
              registeredat:
                moment(item.createdAt).format("MMM DD, YYYY") || "-",
              program: item.program,
              gender: item.gender,
              language: item.language,
              groups: item.groups,
              site: item.site,
              status: item.status,
              // organization: item.organization,
              actions: (
                <Button
                  dataId={item.id}
                  variant="primary"
                  onClick={removeUser(false)}
                >
                  {t("u-archive")}
                </Button>
              )
            };
          });
        };
        const payload = filteredList(list);
        payload.forEach(orgSorter);
        providerDispatch({ type: "UPDATE_MEMBER_LIST", payload: payload });
      })
      .then(() => {
        providerDispatch({
          type: "UPDATE_ORGANIZATION_LIST",
          payload: collectiveClient
        });
      });
    API.kore.devices
      .getAll(Session.crackCookieToken("provider"), "-1")
      .then((list) => {
        devicesDispatch({ type: "UPDATE_DEVICES", payload: list });
      });
    API.kore.notifications
      .getList(Session.crackCookieToken("provider"))
      .then((notifications) => {
        notificationsDispatch({
          type: "UPDATE_BREACHES",
          payload: notifications
        });
      })
      .catch((err) => console.log("notifications error"));
  };

  useEffect(() => {
    callRefresh();
    if (process.env.REACT_APP_NODE_ENV !== "development") {
      const socket = io(socket_url);
      socket.on(`${host[0]}-provider-data-updates`, () => {
        callRefresh();
      });
    }
  }, []);
  return (
    <Grid container>
      <Grid item xs={1} />
      <Grid item xs={10}>
        <StyledContainer>
          <StyledHeader>{t("u-provider")}</StyledHeader>
          <Routes>
            <Route path="/*" element={<Users />} />
            <Route path="managers" element={<Managers />} />
            <Route path="managers/new" element={<Upsert type={"manager"} />} />
            <Route path="reports" element={<Reports />} />
            <Route path="statistics" element={<Statistics />} />
            <Route path="configurations" element={<Configurations />} />
            <Route path="global/thresholds" element={<GlobalThresholds />} />
            <Route path="orders" element={<Orders />} />
          </Routes>
        </StyledContainer>
      </Grid>
      <Grid item xs={1} />
    </Grid>
  );
}
